export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'cs',
  defaultLocale: 'cs',
}))
